import React, { useContext, useMemo, useRef } from 'react';
import classNames from 'classnames';
import EmptyState from './components/EmptyState';
import { Loader } from 'ncoded-component-library';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';
import RfiRequestsTable from './components/RfiRequestsTable';
import RfiTemplatesTable from './components/RfiTemplatesTable';

import './RfiList.styles.scss';

type RfiListProps = {
  className?: string;
};

const RfiList: React.FC<RfiListProps> = (props) => {
  const { className } = props;

  const { isRfiListLoading, isEmpty } = useContext(RfiContext);

  const classes = classNames('rfi-list', 'white-panel', className);

  const hasLoadedOnce = useRef(false);

  if (!isRfiListLoading) hasLoadedOnce.current = true;

  const showInitialLoader = isRfiListLoading && !hasLoadedOnce.current;

  const showEmptyPage = useMemo(
    () => !isRfiListLoading && isEmpty,
    [isRfiListLoading, isEmpty],
  );

  return (
    <div className={classes}>
      {showInitialLoader ? (
        <Loader overlay={false} />
      ) : showEmptyPage ? (
        <EmptyState />
      ) : (
        <>
          <RfiRequestsTable />
          <RfiTemplatesTable />
        </>
      )}
    </div>
  );
};

export default RfiList;
